import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from 'src/app/modules/shared/state/signal-entity.store';
import {ClaimState, ClaimStore} from './claims-session.store';
import {ClaimDetails} from 'src/app/modules/shared/models/claim.model';

@Injectable({ providedIn: 'root' })
export class ClaimQuery extends SignalEntityQuery<ClaimDetails, ClaimState>{
    constructor(protected store: ClaimStore) {
        super(store);
    }

    getClaims(): Observable<any>{
        return this.selectAll();
    }
}
